import { createSlice } from '@reduxjs/toolkit';

// Initial state for the device-related data
const initialState = {
  subadmins: [], // List of subadmins fetched from API
  clientAdmins: [], // List of client admins fetched based on selected subadmin or logged-in subadmin
  devices: [], // Devices for the CURRENT page (server-side pagination)
  totalCount: 0, // Total devices matching the current filters (from server)
  page: 1, // Current page (1-based)
  limit: 10, // Page size
  totalPages: 0, // Total pages = ceil(totalCount / limit)
  loading: false, // Loading state for API calls
  error: null, // Error state for any issues
};

// Create the device slice with actions for setting data
const deviceSlice = createSlice({
  name: 'device',
  initialState,
  reducers: {
fetchsupervisorstart:(state)=>{ 
  state.loading=true;
  state.error=null;
},
fetchsupervisorsuccess:(state,action)=>{
  state.supervisors=action.payload;
  state.loading=false;
},
fetchsupervisorfailure:(state,action)=>{
  state.loading=false;
  state.error=action.payload;
},


    fetchSubadminsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSubadminsSuccess: (state, action) => {
      state.subadmins = action.payload;
      state.loading = false;
    },
    fetchSubadminsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchClientAdminsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchClientAdminsSuccess: (state, action) => {
      state.clientAdmins = action.payload;
      state.loading = false;
    },
    fetchClientAdminsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchDevicesStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchDevicesSuccess: (state, action) => {
      const payload = action.payload;
      // Support both the legacy shape (a plain array) and the new paginated
      // shape ({ devices, totalCount, page, limit, totalPages }).
      if (Array.isArray(payload)) {
        state.devices = payload;
        state.totalCount = payload.length;
        state.page = 1;
        state.totalPages = 1;
      } else if (payload && typeof payload === 'object') {
        state.devices = payload.devices || [];
        if (payload.totalCount !== undefined) state.totalCount = payload.totalCount;
        if (payload.page !== undefined) state.page = payload.page;
        if (payload.limit !== undefined) state.limit = payload.limit;
        if (payload.totalPages !== undefined) state.totalPages = payload.totalPages;
      }
      state.loading = false;
    },
    fetchDevicesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Insert or update a single device without disturbing pagination — used by
    // fetchDeviceByCode so a deep link / refresh to the control panel works even
    // when the device isn't on the currently loaded page.
    upsertDevice: (state, action) => {
      const dev = action.payload;
      if (!dev) return;
      const idx = state.devices.findIndex((d) => d.deviceId === dev.deviceId);
      if (idx >= 0) state.devices[idx] = dev;
      else state.devices.push(dev);
      state.loading = false;
    },
    createDeviceSuccess: (state, action) => {
      state.devices.push(action.payload);
      state.loading = false;
    },
    createDeviceFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    editDeviceStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    editDeviceSuccess: (state, action) => {
      const updatedDevice = action.payload;
      state.devices = state.devices.map((device) =>
        device.device_id === updatedDevice.device_id ? updatedDevice : device
      );
      state.loading = false;
    },
    editDeviceFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    toggleDeviceStatusStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    toggleDeviceStatusSuccess: (state, action) => {
      const updatedDevice = action.payload;
      state.devices = state.devices.map((device) =>
        device.device_id === updatedDevice.device_id ? updatedDevice : device
      );
      state.loading = false;
    },
    toggleDeviceStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Export actions for dispatch
export const {
  fetchSubadminsStart,
  fetchSubadminsSuccess,
  fetchSubadminsFailure,
  fetchClientAdminsStart,
  fetchClientAdminsSuccess,
  fetchClientAdminsFailure,
  fetchDevicesStart,
  fetchDevicesSuccess,
  fetchDevicesFailure,
  upsertDevice,
  createDeviceSuccess,
  createDeviceFailure,
  editDeviceStart,
  editDeviceSuccess,
  editDeviceFailure,
  toggleDeviceStatusStart,
  toggleDeviceStatusSuccess,
  toggleDeviceStatusFailure,
  fetchsupervisorstart,
  fetchsupervisorfailure,
  fetchsupervisorsuccess

} = deviceSlice.actions;

export default deviceSlice.reducer;
